import { FloatingPortal } from '@floating-ui/react-dom-interactions'
import cx from 'classnames'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import React, { ReactNode } from 'react'

import { useMobileToolbar } from '../stores/MobileToolbarStore'
import { useCollaborationDialog } from './CollaborationDialogStore'

import Styles from './CollaborationDialogBody.module.scss'

export const CollaborationDialogBody = observer(
  React.forwardRef<HTMLDivElement, { children: ReactNode }>(function CollaborationDialogBody({ children }, ref) {
    const collaborationDialogStore = useCollaborationDialog()
    const mobileToolbarStore = useMobileToolbar()

    const forcedStyle = computed(() =>
      mobileToolbarStore.keyboardCoversContent ? { bottom: `${mobileToolbarStore.appleBottom}px` } : {},
    ).get()

    return (
      <FloatingPortal id="floating-ui-root">
        <div
          ref={ref}
          className={cx(Styles.wrapper, {
            [Styles.fullscreenBody]: collaborationDialogStore.fullScreen,
          })}
          onClick={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          style={forcedStyle}
        >
          {children}
        </div>
      </FloatingPortal>
    )
  }),
)
